import React from 'react';
import SkeletonStyles from './Skeletons.module.css';

const ButtonSkeleton = ({style}) => {
	return <div className={[ SkeletonStyles.button, SkeletonStyles.skeleton ].join(' ')} style={style} />;
};

export default ButtonSkeleton;
